import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './creditLimits.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    accounts: 'all',
    tags: [],
    includeClosed: false,
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="cl-wrap">
      {/* Description Line */}
      <div className="cl-desc">Current account balances and respective credit limits.</div>

      <div className="cl-box">
        {/* Section Heading */}
        <h2 className="cl-title">Parameters</h2>

        {/* Form Card Container */}
        <form onSubmit={handleSubmit} className="cl-panel">
          {/* Accounts Field */}
          <div className="cl-row">
            <label htmlFor="accounts" className="cl-label">Accounts</label>
            <div className="cl-field">
              <select
                id="accounts"
                name="accounts"
                value={formData.accounts}
                onChange={handleChange}
                className="cl-select"
              >
                <option value="all">All</option>
                <option value="with">With Credit Limit</option>
                <option value="at">At Credit Limit</option>
              </select>

              <label className="cl-check">
                <input
                  type="checkbox"
                  name="includeClosed"
                  checked={formData.includeClosed}
                  onChange={handleChange}
                />
                Include Closed
              </label>
            </div>
          </div>

          {/* Account Tags Field */}
          <div className="cl-row">
            <label htmlFor="tags" className="cl-label">Account Tags</label>
            <div className="cl-field">
              <select
                id="tags"
                name="tags"
                multiple
                value={formData.tags}
                onChange={handleChange}
                style={{ display: 'none' }}
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </select>

              <button type="button" className="cl-tags-btn">
                {formData.tags.length > 0 ? formData.tags.join(', ') : 'No filter'}
              </button>
            </div>
          </div>

          {/* Format Field */}
          <div className="cl-row">
            <label htmlFor="format" className="cl-label">
              Format <span className="cl-req">*</span>
            </label>
            <div className="cl-field">
              <select
                id="format"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="cl-select"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="cl-row cl-row-run">
            <span className="cl-label" />
            <Link to="/AddRevenueCredit" className="cl-link">
              <button type="submit" className="cl-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportForm;